import { render } from "./share-popper.vue?vue&type=template&id=1f754d3c"
import script from "./share-popper.vue?vue&type=script&lang=js"
export * from "./share-popper.vue?vue&type=script&lang=js"

import "./share-popper.vue?vue&type=style&index=0&id=1f754d3c&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-detail-info/share-popper.vue'],['render',render],['__file',"share-popper.vue"]])

export default __exports__